import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import theme from "Styles/theme";

const CAMERA_ZOOM_MAX = theme.size.zoom.max;
const CAMERA_ZOOM_MIN = theme.size.zoom.min;

export const renderControls = (camera: any, dom: any) => {
	const controls = new OrbitControls(camera, dom);

	controls.maxZoom = CAMERA_ZOOM_MAX;
	controls.minZoom = CAMERA_ZOOM_MIN;
	controls.maxPolarAngle = 2;
	controls.maxAzimuthAngle = -Math.PI;

	controls.update();
	return controls;
};

export const controlsAnimation = (controls: any, x: number, y: number) => {
	// controls.target.x++;

	controls.update();
};
